export default "__VITE_ASSET__CvBDbXp3__";